import { recipeApp, type OsRecipe } from '../os-recipes.js';

const EXCEL = recipeApp('com.microsoft.Excel');

/** excel: its app recipes as data (Mac recipes R3). Every entry ships held until its drill lifts it.
 *  Each acts on the front workbook's active sheet, with Excel named or in front. Most of Excel's acts
 *  wait on an Excel verb pack (the pending verbs list). The research rows not here are on the R3
 *  review lists. */
export const RECIPES: readonly OsRecipe[] = [
  {
    id: 'excel.new_workbook', app: EXCEL, status: 'held', opens: true,
    title: 'New blank workbook',
    description: 'New blank workbook ("new workbook").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+n' }],
    tier: 'reversible', cues: ['blank', 'new workbook', 'new spreadsheet', 'new excel file', 'blank workbook', 'blank spreadsheet', 'blank excel sheet'],
    reply: 'Started a new workbook in Excel.',
  },
  // A save overwrites the file on disk (the catalog audit leaves saves for the yes); a new workbook opens the Save dialog, the person's to name.
  {
    id: 'excel.save', app: EXCEL, status: 'held',
    title: 'Save the workbook',
    description: 'Save the workbook ("save").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'key', chord: 'cmd+s' }],
    tier: 'irreversible', cues: ['save', 'save this', 'save the workbook', 'save my spreadsheet', 'save it'],
    reply: 'Save this workbook in Excel?',
  },
  // The catalog audit leaves saves for the yes; the yes only opens the dialog, and nothing is typed.
  {
    id: 'excel.save_as', app: EXCEL, status: 'held',
    title: 'Save As',
    description: 'Save As ("save as").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'key', chord: 'cmd+shift+s' }],
    tier: 'irreversible', cues: ['save as', 'copy', 'new name', 'save a copy'],
    reply: 'Open Save As for this workbook in Excel?',
  },
  // A close is a destructive menu word to the lint; Excel's own "save changes?" sheet stays the person's.
  {
    id: 'excel.close_workbook', app: EXCEL, status: 'held',
    title: 'Close the workbook',
    description: 'Close the workbook ("close this workbook").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'menu', path: ['File', 'Close'] }],
    tier: 'irreversible', cues: ['close', 'band', 'close this workbook', 'close the spreadsheet', 'close excel file', 'ye file band', 'close this excel file', 'close the workbook'],
    reply: 'Close this workbook in Excel?',
  },
  {
    id: 'excel.fullscreen', app: EXCEL, status: 'held',
    title: 'Put Excel in full screen',
    description: 'Excel full screen ("make excel full screen").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'ctrl+cmd+f' }],
    tier: 'reversible', cues: ['full screen', 'fullscreen', 'full screen the spreadsheet', 'exit full screen'],
    reply: 'Toggled full screen.',
  },
  {
    id: 'excel.select_row', app: EXCEL, status: 'held',
    title: 'Select the row in Excel',
    description: 'Select the row in Excel ("select this row").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'focus_not_editable' }, { op: 'key', chord: 'shift+space' }],
    tier: 'reversible', cues: ['select', 'highlight', 'row', 'select this', 'poori row', 'entire row'],
    reply: 'Selected the row.',
  },
  // Printing is outward (the catalog audit leaves prints for the yes); the yes only opens the dialog.
  {
    id: 'excel.print_dialog', app: EXCEL, status: 'held',
    title: 'Open Print',
    description: 'Open Print ("print this").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'key', chord: 'cmd+p' }],
    tier: 'irreversible', cues: ['print', 'print this', 'print the sheet', 'print the spreadsheet', 'print this workbook', 'print dialog'],
    reply: 'Open the print window for this workbook in Excel?',
  },
  // Sharing is outward: the yes only opens the Share pane, and the person picks who gets it.
  {
    id: 'excel.share', app: EXCEL, status: 'held',
    title: 'Open Share',
    description: 'Open Share ("share this workbook").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'menu', path: ['File', 'Share'] }],
    tier: 'irreversible', yesWord: 'share', cues: ['share', 'send', 'share this workbook', 'send this excel file', 'share karo ye file', 'share this file'],
    reply: 'Share this workbook from Excel?',
  },  // ── R3c: the catalog rulings' accepts ─────────────────────────────────────────────────────────
  // The Format Cells dialog only: nothing changes until OK, which nothing presses before a yes. Bold, italic and fill stay out (they edit cells).
  {
    id: 'excel.format_cells', app: EXCEL, status: 'held', opens: true,
    title: 'Open Format Cells',
    description: 'Open the Format Cells dialog for the selected cells ("open format cells").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+1' }],
    tier: 'reversible', cues: ['format', 'format cells', 'format cells dialog', 'cell format'],
    reply: 'Opened Format Cells in Excel.',
  },
];
